import BaseUrl from "../component/BaseUrl";

export const getDashboardStats = async () => {

    try {
        const config = {
            headers: { Authorization: `Bearer ${JSON.parse(localStorage.getItem('pacificadmin'))?.token?.token}` }
        };
        const response = await BaseUrl.get("/api/Dashboard/GetDashboardStats", config);
        return response;
    } catch (err) {
        return err.response
    }
}